<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { RouteOne } from './Routes/RouteOne';
    import Distance from '../../shared/Distance.svelte';
    import Duration from '../../shared/Duration.svelte';
    import { features } from '../../shared/Features/features';

    export let routeOne: RouteOne;

    // let countryRoadsMeters = routeOne.getCalculationResult().getCountryRoadsMeters();
    // let expressRoadsMeters = routeOne.getCalculationResult().getExpressRoadsMeters();
    // let highwayRoadsMeters = routeOne.getCalculationResult().getHighwayRoadsMeters();
    // // let totalMeters = routeOne.getCalculationResult().getRouteMeters();
    // let otherRoadsMeters = 0;
    // if (totalMeters) {
    //     otherRoadsMeters = totalMeters - (countryRoadsMeters ?? 0) - (expressRoadsMeters ?? 0) - (highwayRoadsMeters ?? 0);
    // }
    // let countryRoadsTimeSeconds = routeOne.getCalculationResult().getCountryRoadsTimeSeconds();
    // let expressRoadsTimeSeconds = routeOne.getCalculationResult().getExpressRoadsTimeSeconds();
    // let highwayRoadsTimeSeconds = routeOne.getCalculationResult().getHighwayRoadsTimeSeconds();
    // // let totalSeconds = routeOne.getCalculationResult().getTotalTimeSeconds();
    // let otherRoadsTimeSeconds = routeOne.getCalculationResult().getOtherRoadsTimeSeconds();
    // if (totalSeconds) {
    //     otherRoadsTimeSeconds =
    //         totalSeconds - (countryRoadsTimeSeconds ?? 0) - (expressRoadsTimeSeconds ?? 0) - (highwayRoadsTimeSeconds ?? 0);
    // }
</script>

<div class="route-summary-by-type-container">
    <div class="route-summary-by-type-row">
        <div class="title">{$_('National roads:')}</div>
        <div class="distance">
            <Distance meters={routeOne.getCalculationResult().getCountryRoadsMeters()} />
        </div>
        <div class="duration">
            <Duration seconds={routeOne.getCalculationResult().getCountryRoadsTimeSeconds()} />
        </div>
    </div>
    <div class="route-summary-by-type-row">
        <div class="title">{$_('Express roads:')}</div>
        <div class="distance">
            <Distance meters={routeOne.getCalculationResult().getExpressRoadsMeters()} />
        </div>
        <div class="duration">
            <Duration seconds={routeOne.getCalculationResult().getExpressRoadsTimeSeconds()} />
        </div>
    </div>
    <div class="route-summary-by-type-row">
        <div class="title">{$_('Highways:')}</div>
        <div class="distance">
            <Distance meters={routeOne.getCalculationResult().getHighwayRoadsMeters()} />
        </div>
        <div class="duration">
            <Duration seconds={routeOne.getCalculationResult().getHighwayRoadsTimeSeconds()} />
        </div>
    </div>
    {#if $features.feature_show_other_routes_calculation}
        <div class="route-summary-by-type-row">
            <div class="title">{$_('Other/free:')}</div>
            <div class="distance">
                <Distance meters={routeOne.getCalculationResult().getOtherRoadsMeters()} />
            </div>
            <div class="duration">
                <Duration seconds={routeOne.getCalculationResult().getOtherRoadsTimeSeconds()} />
            </div>
        </div>
    {/if}
</div>

<style>
    .route-summary-by-type-row {
        display: flex;
        justify-content: space-between;
        padding: 1px 0;
        column-gap: 20px;
    }
    .route-summary-by-type-row .title {
        min-width: 120px;
        text-align: right;
        flex: 1;
    }
    .route-summary-by-type-row .distance,
    .route-summary-by-type-row .duration {
        flex: 0 1 80px;
    }
</style>
